export default __webpack_public_path__ + "static/media/Leg_right.bf7d1492.svg";